import { render, staticRenderFns } from "./CRMDataField.vue?vue&type=template&id=fef65546"
import script from "./CRMDataField.vue?vue&type=script&lang=ts"
export * from "./CRMDataField.vue?vue&type=script&lang=ts"
import style0 from "./CRMDataField.vue?vue&type=style&index=0&id=fef65546&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports